// extracted by mini-css-extract-plugin
export default {"container":"ImagePreview_container__I6CI-","image":"ImagePreview_image__etd8M","clickable":"ImagePreview_clickable__zqvbj","closeIcon":"ImagePreview_closeIcon__ZNkUD"};